import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { paths } from '../models/paths';

const siteUrl = 'https://www.purenestcleaning.co.nz';

// Pages built on src/templates/PageShell.js render their own trail.
const trails = {
  [paths.commercial]: [['Commercial Cleaning', paths.commercial]],
  [paths.houseHub]: [['House Cleaning', paths.houseHub]],
  [paths.prices]: [
    ['House Cleaning', paths.houseHub],
    ['Prices', paths.prices],
  ],
  [paths.projects]: [['Commercial Cleaning', paths.commercial], ['Projects', paths.projects]],
  [paths.contact]: [['Contact', paths.contact]],
};

// Visible breadcrumb trail plus matching BreadcrumbList JSON-LD (task D15).
export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const rest = trails[pathname.replace(/\/$/, '')];
  if (!rest) return null;
  const items = [['Home', '/'], ...rest];

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map(([name, path], i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name,
      item: `${siteUrl}${path === '/' ? '' : path}`,
    })),
  };

  return (
    <nav aria-label="Breadcrumb" style={{ background: '#f4f8f5', padding: '0.9rem 0', fontSize: '0.875rem' }}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <ol className="container" style={{ listStyle: 'none', margin: '0 auto', padding: '0 1.5rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
        {items.map(([name, path], i) => (
          <li key={path} style={{ display: 'flex', gap: '0.5rem' }}>
            {i < items.length - 1 ? (
              <>
                <Link to={path} style={{ color: '#006837' }}>{name}</Link>
                <span aria-hidden="true">›</span>
              </>
            ) : (
              <span aria-current="page">{name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
